module.exports = __webpack_public_path__ + "static/media/026_IMG_5491.f801a6f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/026_IMG_5491.png
// module id = 592
// module chunks = 0